import { combineReducers } from 'redux';
import authReducer from './authSlice';
import searchReducer, { ISearchSliceState } from './searchSlice';
import settingsSlice, { ISettingsSliceState } from './settingsSlice';
import bulkOperationsReducer from './bulkOperationsSlice';
import aiAssistantReducer, {IAiAssistantState, persistKey as aiAssistantPersistKey} from './aiAssistantSlice';
import localStorage from 'redux-persist/lib/storage'
import sessionStorage from 'redux-persist/lib/storage/session'
import { persistReducer } from 'redux-persist';
import api from "./Api";
import {isSupportTab} from "../logic/supportSession";

// A support tab persists to sessionStorage instead: the customer organization, searches and the like must not be
// written where the person's own tabs would pick them up on their next load (see logic/supportSession.ts).
const storage = isSupportTab() ? sessionStorage : localStorage;

const searchPersistConfig = {
    key: 'search',
    storage,
}

const settingsPersistConfig = {
    key: 'settings',
    storage,
    blacklist: [
        'loggingOut', 
        'punchoutWorkspace',
        'effectiveClaims', 
        'externalQuoteId', 
        'externalQuotePartitionId', 
        'punchoutMode',
        'selectedWorkspaceId',
        // Transient UI intent, not a preference — a rehydrated value would pop the bundle editor
        // open on a fresh load.
        'openBundleId'
    ]
}

// Only the dock's shape survives a reload. isOpen and activeSessionId are deliberately blacklisted:
// a reload should not reopen a panel the user closed, nor drop the user back inside a conversation.
const aiAssistantPersistConfig = {
    key: aiAssistantPersistKey,
    storage,
    blacklist: ['isOpen', 'activeSessionId'],
}

export const rootReducer = combineReducers({
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    search: persistReducer<ISearchSliceState>(searchPersistConfig, searchReducer),
    settings: persistReducer<ISettingsSliceState>(settingsPersistConfig, settingsSlice),
    // Deliberately NOT wrapped in persistReducer: in-flight bulk ops must not survive a reload
    // (a stale "pending op" would wrongly re-arm the beforeunload warning).
    bulkOperations: bulkOperationsReducer,
    aiAssistant: persistReducer<IAiAssistantState>(aiAssistantPersistConfig, aiAssistantReducer),
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;